import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { tabIconFiles, tabIconFor } from "@/lib/tabIcon";

/** Keeps the browser tab's icon on the current tool. */
export function TabIconSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    const { svg, png } = tabIconFiles(tabIconFor(pathname));
    document.querySelector('link[rel="icon"][type="image/svg+xml"]')?.setAttribute("href", svg);
    document.querySelector('link[rel="icon"][type="image/png"]')?.setAttribute("href", png);
  }, [pathname]);
  return null;
}
